import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { ChartData, ChartOptions } from 'chart.js/auto';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-custom-chart',
  templateUrl: './custom-chart.component.html',
  styleUrls: ['./custom-chart.component.css']
})



export class CustomChartComponent extends BaseListCtl {
  @Input() appId: number = 0;
  @Input() usecaseId: number | null = 0;
  @Input() uiformId: number | null = 0; // pass as a input 
  @Input() id: number | null = 0;

  public cachedChartData: { [key: string]: any } = {}; // Cache to store chart data

  public usecaseSchema: any = {
  };
  @ViewChild('content')content! : ElementRef;

  constructor(public override locator: ServiceLocatorService, public override route: ActivatedRoute) {
    super(locator.config.get("endpoint.ui.forms"), locator, route);
    let _self = this;

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
    if (data.buttons) {
      form.buttons = data.buttons;
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['uiformId']) {
      this.ngOnInit(); // Call ngOnInit or relevant method only if uiformId changes
    }
  }

  override ngOnInit() {
    let _self = this;
    if (_self.uiformId) {
      console.log(_self.uiformId);
      this.get(_self.uiformId, function () {
        _self.usecaseId = _self.form.data.userstoryId
        console.log(_self.form);
        _self.getUsecaseSchema();
      })
    }
  }




  public attributeList: any = [];

  public getUsecaseSchema() {
    let _self = this;
    let url = _self.locator.config.get("endpoint.userstory") + "/get/" + _self.usecaseId;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.usecaseSchema = res.result.data;
      // _self.attributeId = _self.usecaseSchema['appId']
      console.log("usecaseSchema", _self.usecaseSchema);

      _self.getUiformDataList();

    });
    let attrUrl = _self.locator.config.get("endpoint.userstory.attributes") + "/list/" + _self.usecaseId;
    //{ userstoryId: _self.usecaseId },
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;


    });
  }

  public uiformDataList = [];

  /**
  * get usecase records list
  */
  public getUiformDataList() {
    let _self = this;
    let url = _self.getAPIBaseUrl() + "/search";
    _self.locator.http.post(url, {}, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.uiformDataList = res.result["data"];
    });

  }

  charts: any[] = [];


  public getChartData(field: any): any {

    if (this.cachedChartData[field.code]) {
      return this.cachedChartData[field.code];
    }

    const labels = field.values;

    const chartData = labels.map((value: string) => {
      return this.uiformDataList.filter(item => item[field.code] === value).length;
    });



    //console.log("getChartData calling "+chartData)
    // Generate dynamic colors based on the number of data points
    const backgroundColors = this.generateColors(chartData.length);
    // console.log("backgroundColors calling ",backgroundColors);

    let data = {
      labels: labels,
      datasets: [{
        label: field.label,
        data: chartData,
        backgroundColor: backgroundColors // Set dynamic colors here
      }]
    };

    // Cache the generated chart data
    this.cachedChartData[field.code] = data;

    return data;
  }

  clearChartDataCache(): void {
    this.cachedChartData = {};
  }


  // Helper function to generate random colors
  private generateColors(count: number): string[] {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.7)`;
      colors.push(color);
    }
    return colors;
  }

  public getPieData(field: any): any {
    if (this.cachedChartData[field.code]) {
      return this.cachedChartData[field.code];
    }

    const labels = field.values;
    const chartData = labels.map((value: string) => {
      return this.uiformDataList.filter(item => item[field.code] === value).length;
    });

    // console.log("getChartData pie calling ",chartData);

    // Generate dynamic colors based on the number of data points
    const backgroundColors = this.generateColors(chartData.length);
    // console.log("backgroundColors calling ",backgroundColors);
    let data = {
      labels: labels,
      datasets: [{
        label: field.label,
        data: chartData,
        backgroundColor: backgroundColors // Set dynamic colors here
      }]
    };


    // Cache the generated chart data
    this.cachedChartData[field.code] = data;

    return data;
  }

  /**
   * Get API base URL
   * @returns 
   */
  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }

  // Line chart data
  lineChartData: ChartData = this.getInitialLineChartData();
  // Bar chart data
  barChartData: ChartData = this.getInitialBarChartData();
  // Pie chart data
  pieChartData: ChartData = this.getInitialPieChartData();
  // Doughnut chart data
  doughnutChartData: ChartData = this.getInitialDoughnutChartData();

  // Chart options
  chartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top', // Display legend on top of the chart
        labels: {
          color: 'black' // Legend label color (adjust as needed)
        }
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            // Customize the tooltip display for each segment
            const label = tooltipItem.label || '';
            const value = tooltipItem.raw || 0;
            return `${label}: ${value}`;
          }
        }
      }
    }
  };

  // Generate initial data for Line Chart
  getInitialLineChartData(): ChartData {
    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'view',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: 'blue',
          tension: 0.1
        }
      ]
    };
  }

  // Generate initial data for Bar Chart
  getInitialBarChartData(): ChartData {
    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'No of users',
          data: [75, 50, 90, 81, 56, 55, 40],
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1
        }
      ]
    };
  }

  // Generate initial data for Pie Chart
  getInitialPieChartData(): ChartData {
    return {
      labels: ['Red', 'Blue', 'Yellow'],
      datasets: [
        {
          label: 'Pie Dataset',
          data: [30, 40, 30],
          backgroundColor: ['red', 'blue', 'yellow']
        }
      ]
    };
  }

  // Generate initial data for Doughnut Chart
  getInitialDoughnutChartData(): ChartData {
    return {
      labels: ['Green', 'Purple', 'Orange'],
      datasets: [
        {
          label: 'Doughnut Dataset',
          data: [40, 30, 30],
          backgroundColor: ['green', 'purple', 'orange']
        }
      ]
    };
  }

  // Refresh data for all charts
  refreshChart(): void {
    this.lineChartData = this.getRandomLineChartData();
    this.barChartData = this.getRandomBarChartData();
    this.pieChartData = this.getRandomPieChartData();
    this.doughnutChartData = this.getRandomDoughnutChartData();
    console.log('All charts refreshed with new random data!');
  }

  refreshLineChart(): void {
    this.lineChartData = this.getRandomLineChartData();
    console.log('Line chart refresh to initial data!');
  }

  refreshBarChart(): void {
    this.barChartData = this.getRandomBarChartData();
    console.log('Bar chart refresh to initial data!');
  }

  refreshPieChart(): void {
    this.pieChartData = this.getRandomPieChartData();
    console.log('Pie chart refresh to initial data!');
  }

  refreshDoughnutChart(): void {
    this.doughnutChartData = this.getRandomDoughnutChartData();
    console.log('Doughnut chart refresh to initial data!');
  }

  // Reset individual charts
  resetLineChart(): void {
    this.lineChartData = this.getInitialLineChartData();
    console.log('Line chart reset to initial data!');
  }

  resetBarChart(): void {
    this.barChartData = this.getInitialBarChartData();
    console.log('Bar chart reset to initial data!');
  }

  resetPieChart(): void {
    this.pieChartData = this.getInitialPieChartData();
    console.log('Pie chart reset to initial data!');
  }

  resetDoughnutChart(): void {
    this.doughnutChartData = this.getInitialDoughnutChartData();
    console.log('Doughnut chart reset to initial data!');
  }

  // Generate random data for Line Chart
  getRandomLineChartData(): ChartData {
    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Line Dataset',
          data: Array(7).fill(0).map(() => Math.round(Math.random() * 100)),
          fill: false,
          borderColor: 'blue',
          tension: 0.1
        }
      ]
    };
  }

  // Generate random data for Bar Chart
  getRandomBarChartData(): ChartData {
    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Bar Dataset',
          data: Array(7).fill(0).map(() => Math.round(Math.random() * 100)),
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1
        }
      ]
    };
  }

  // Generate random data for Pie Chart
  getRandomPieChartData(): ChartData {
    return {
      labels: ['Red', 'Blue', 'Yellow'],
      datasets: [
        {
          label: 'Pie Dataset',
          data: Array(3).fill(0).map(() => Math.round(Math.random() * 100)),
          backgroundColor: ['red', 'blue', 'yellow']
        }
      ]
    };
  }

  // Generate random data for Doughnut Chart
  getRandomDoughnutChartData(): ChartData {
    return {
      labels: ['Green', 'Purple', 'Orange'],
      datasets: [
        {
          label: 'Doughnut Dataset',
          data: Array(3).fill(0).map(() => Math.round(Math.random() * 100)),
          backgroundColor: ['green', 'purple', 'orange']
        }
      ]
    };
  }



  getMaxValues(field: any): number {
    // Filter only objects that have the 'balance' property
    const max_values = this.uiformDataList
      .filter(item => item[field.code] !== undefined && item[field.code] !== null) // Ensure balance exists
      .map(item => item[field.code]); // Extract the balance values

    // Return the maximum balance
    return max_values.length > 0 ? Math.max(...max_values) : 0;
  }

  public getChartAggrigateData(field: any): any {
    if (this.cachedChartData[field.code]) {
      return this.cachedChartData[field.code];
    }
    // get max value   
    let max_values = this.getMaxValues(field);
    // Step 2: Define the range intervals
    const rangeSize = max_values / 4;
    // Define the ranges
    const range1 = { min: 0, max: rangeSize };                 // Range 1: 0 to 25% of max
    const range2 = { min: rangeSize, max: 2 * rangeSize };      // Range 2: 25% to 50% of max
    const range3 = { min: 2 * rangeSize, max: 3 * rangeSize };  // Range 3: 50% to 75% of max
    const range4 = { min: 3 * rangeSize, max: max_values };     // Range 4: 75% to 100% of max

    // Step 3: Initialize counters for each range
    let countRange1 = 0;
    let countRange2 = 0;
    let countRange3 = 0;
    let countRange4 = 0;

    // Step 4: Loop through the data and count how many balances fall into each range
    this.uiformDataList.forEach(item => {
      const value = item[field.code];
      if (value !== undefined && value !== null) {
        if (value >= range1.min && value <= range1.max) {
          countRange1++;
        } else if (value > range2.min && value <= range2.max) {
          countRange2++;
        } else if (value > range3.min && value <= range3.max) {
          countRange3++;
        } else if (value > range4.min && value <= range4.max) {
          countRange4++;
        }
      }
    });

    let labels = [`${range1.min} - ${range1.max}`, `${range2.min} - ${range2.max}`, `${range3.min} - ${range3.max}`, `${range4.min} - ${range4.max}`]

    let chartData = [countRange1, countRange2, countRange3, countRange4]

    let data = {
      labels: labels,
      datasets: [{
        label: field.label,
        data: chartData
      }]
    };
    this.cachedChartData[field.code] = data;
    return data;

  }


   /**
   * Download PDF HTML
   */
   downloadPDF() {
    // Options for PDF generation
    const element = this.content.nativeElement;
    // Wait for images to load
    const images = Array.from(element.getElementsByTagName('img')) as HTMLImageElement[];
    const promises = images.map((img) => {
      return new Promise<void>((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = () => resolve();
          img.onerror = () => resolve(); // Handle error
        }
      });
    });
  
    Promise.all(promises).then(() => {
      const options = {
        margin: 0.5,
        filename: 'document_with_image.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' },
      };
  
      html2pdf().from(element).set(options).save();
    });  
  }
}
